import { render, staticRenderFns } from "./sobre-sdconsulta.vue?vue&type=template&id=e420c6ec&scoped=true"
import script from "./sobre-sdconsulta.vue?vue&type=script&lang=js"
export * from "./sobre-sdconsulta.vue?vue&type=script&lang=js"
import style0 from "./sobre-sdconsulta.vue?vue&type=style&index=0&id=e420c6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e420c6ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SolicitacaoSDCForm: require('/home/luiz/Sistemas/loja/components/SolicitacaoSDC/Form.vue').default,ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
